import { echartSetOption } from './echarts-utils';
/* -------------------------------------------------------------------------- */
/*                     Echart booking value                                 */
/* -------------------------------------------------------------------------- */

const bookingValueChartInit = () => {
  const { getColor, getData, getDates } = window.phoenix.utils;
  const $echartBookingValue = document.querySelector('.echart-booking-value');
  const tooltipFormatter = params => {
    const currentDate = window.dayjs(params[0].axisValue);
    const prevDate = window.dayjs(params[0].axisValue).subtract(1, 'month');

    const result = params.map((param, index) => ({
      value: param.value,
      date: index > 0 ? prevDate : currentDate,
      color: param.color
    }));

    let tooltipItem = ``;
    result.forEach((el, index) => {
      tooltipItem += `<h6 class="fs-9 ${
        index > 0 && 'mb-0'
      }"><span class="fas fa-circle me-2" style="color:${el.color}"></span>
      ${el.date.format('MMM DD')} : <span class="font-normal">${el.value}</span>
    </h6>`;
    });
    return `<div class='ms-1'>
              ${tooltipItem}
            </div>`;
  };

  if ($echartBookingValue) {
    const userOptions = getData($echartBookingValue, 'echarts');
    const chart = window.echarts.init($echartBookingValue);
    const getDefaultOptions = () => ({
      tooltip: {
        trigger: 'axis',
        padding: 10,
        backgroundColor: getColor('background-color-subtle'),
        borderColor: getColor('border-color-default'),
        textStyle: { color: getColor('text-color-emphasis') },
        borderWidth: 1,
        transitionDuration: 0,
        axisPointer: {
          type: 'none'
        },
        formatter: params => tooltipFormatter(params),
        extraCssText: 'z-index: 1000'
      },
      xAxis: [
        {
          type: 'category',
          data: getDates(
            new Date('11/1/2023'),
            new Date('11/7/2023'),
            1000 * 60 * 60 * 24
          ),
          show: true,
          boundaryGap: false,
          axisLine: {
            show: true,
            lineStyle: { color: getColor('background-color-muted') }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          }
        }
      ],
      yAxis: {
        show: false,
        type: 'value',
        boundaryGap: false
      },
      series: [
        {
          type: 'line',
          data: [150, 100, 300, 200, 250, 180, 250],
          showSymbol: false,
          symbol: 'circle',
          lineStyle: {
            width: 2,
            color: getColor('color-warning')
          },
          emphasis: {
            lineStyle: {
              color: getColor('color-warning')
            }
          },
          itemStyle: {
            color: getColor('color-warning')
          },
          zlevel: 1
        }
      ],
      grid: { left: 5, right: 5, top: 5, bottom: 0 }
    });
    echartSetOption(chart, userOptions, getDefaultOptions);
  }
};

export default bookingValueChartInit;
